import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { IWorkOrder } from "./models/IWorkOrder";
import { Observable } from "rxjs";
import { IProject } from "../projects/shared/models/IProject";
import { tap } from "rxjs/operators";

const workOrderUrl = "/api/workorder";

@Injectable({
  providedIn: "root",
})
export class WorkOrderService {
  constructor(private http: HttpClient) {}

  getWorkOrders(): Observable<IWorkOrder[]> {
    return this.http.get<IWorkOrder[]>(workOrderUrl);
  }
  getWorkOrdersByProject(projectId: number): Observable<IWorkOrder[]> {
    const params = new HttpParams().set("projectId", projectId.toString());
    return this.http.get<IWorkOrder[]>(workOrderUrl, { params });
  }
  getWorkOrder(workOrderId: number): Observable<IWorkOrder> {
    return this.http.get<IWorkOrder>(`${workOrderUrl}/${workOrderId}`);
  }
  createWorkOrder(workOrder: IWorkOrder): Observable<IWorkOrder> {
    return this.http.post<IWorkOrder>(workOrderUrl, workOrder);
  }
  updateWorkOrder(workOrder: IWorkOrder): Observable<IWorkOrder> {
    return this.http.put<IWorkOrder>(
      `${workOrderUrl}/${workOrder.id}`,
      workOrder
    );
  }
  deleteWorkOrder(workOrderId: number) {
    return this.http.delete<IWorkOrder>(`${workOrderUrl}/${workOrderId}`);
  }

  // must pass in all associated projects,
  // anything not in this list will be unnassociated if applicable
  setWorkOrderProjects(
    workOrderId: number,
    projects: IProject[]
  ): Observable<any> {
    const projectIds = projects.map((p) => p.id);
    return this.http.post(
      `${workOrderUrl}/${workOrderId}/projects`,
      projectIds
    );
  }
  /* *********************************
  ************************************
  Utility
  */
  sortByName(a: IWorkOrder, b: IWorkOrder) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }
  sortByOrder(a: IWorkOrder, b: IWorkOrder) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }
}
